import React, { FunctionComponent } from "react";
import {
    Modal,
    PrimaryButton,
    IconButton
} from "@fluentui/react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
    contentStyles as content,
    iconButtonStyles,
    cancelIcon,
} from "constants/styles";
import { useNavigate  } from "react-router-dom";
import { CustomFontText } from "../../customFontText/CustomFontText";


const contentStyles = content(600, "auto");

interface IProps {
    onDismiss: () => void;
    dealID: any;
    isAppraisal?: any;
    handleAddTradeIn?: any;
}

export const DealRecordFoundDialog: FunctionComponent<IProps> = ({
    onDismiss,
    dealID,
    isAppraisal=false,
    handleAddTradeIn
}) => {
    const navigate = useNavigate ();

    const handleVehicleDetails = () => {
        onDismiss();
        navigate(`/${dealID}/dealtracker`);
    };

    return (
        <Modal
            isOpen={true}
            onDismiss={onDismiss}
            isBlocking={true}
            containerClassName={contentStyles.container + " custom-modal"}
            className="vehicleFoundDialog dealFoundDiaHeight"
        >
            <div className={contentStyles.header + " inventory-popup"}>
                {/*<GoBackToMainDialogBtn label="" onClick={onDismiss} />*/}
                <CustomFontText className="formTitle">Deal Record Found</CustomFontText>

                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={onDismiss}
                />
            </div>
            <div className="dealRecFound body-auto-hight body-min-height-50">
                <div style={{ marginLeft: "25px",marginTop: "-25px",}}>
                    <div>
                        <label className="lbl-text">This Deal Number was already found for this location.</label>
                    </div>
                </div>
            </div>
            <div className={contentStyles.footer + " inventory-popup-footer"}>
                {!isAppraisal ? <div style={{ textAlign: "center", marginTop: "-15px" }}>
                    <PrimaryButton
                        text="View Deal"
                        onClick={handleVehicleDetails}
                    />
                </div>
                    :
                    <div style={{margin: '0px 30px 0px 60px', display: "flex", justifyContent: "space-between" }}>
                        <PrimaryButton
                            text="View Deal"
                            onClick={handleVehicleDetails}
                        />
                        <PrimaryButton
                            text="Add as Trade-In"
                            onClick={handleAddTradeIn}
                            />
                    </div>}
            </div>
        </Modal>
    );
};



